"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "poa"
  }, [_c("div", {
    staticClass: "poa-title"
  }, [_vm._v(_vm._s(this.deviceEntries.name))]), _vm._v(" "), _c("div", {
    staticClass: "poa-centent"
  }, [_c("div", {
    staticClass: "poa-right"
  }, [_c("div", {
    staticClass: "poa-right-img"
  }, [this.type === "sbcsData1" ? _c("img", {
    attrs: {
      src: require("../../../assets/zg_bg.png"),
      alt: ""
    }
  }) : _vm._e(), _vm._v(" "), this.type === "sbcsData2" ? _c("img", {
    attrs: {
      src: require("../../../assets/ldb_bg.png"),
      alt: ""
    }
  }) : _vm._e(), _vm._v(" "), this.type === "sbcsData3" ? _c("img", {
    attrs: {
      src: require("../../../assets/lqb_bg.png"),
      alt: ""
    }
  }) : _vm._e(), _vm._v(" "), this.type === "sbcsData4" ? _c("img", {
    attrs: {
      src: require("../../../assets/lqt_bg.png"),
      alt: ""
    }
  }) : _vm._e()]), _vm._v(" "), _c("div", {
    staticClass: "poa-right-info"
  }, [_c("div", {
    staticClass: "poa-right-num"
  }, [_vm._v(_vm._s(this.deviceEntries.leftNum))]), _vm._v(" "), _c("div", {
    staticClass: "poa-right-text"
  }, [_vm._v(_vm._s(this.deviceEntries.leftText))])])]), _vm._v(" "), _c("div", {
    staticClass: "poa-left"
  }, [_c("div", {
    staticClass: "poa-left-info"
  }, [_c("div", {
    staticClass: "poa-left-num"
  }, [_vm._v(_vm._s(this.deviceEntries.rightTopNum))]), _vm._v(" "), _c("div", {
    staticClass: "poa-left-text"
  }, [_vm._v(_vm._s(this.deviceEntries.rightTopText))])]), _vm._v(" "), _c("div", {
    staticClass: "poa-left-info"
  }, [_c("div", {
    staticClass: "poa-left-num"
  }, [_vm._v(_vm._s(this.deviceEntries.rightBottomNum))]), _vm._v(" "), _c("div", {
    staticClass: "poa-left-text"
  }, [_vm._v(_vm._s(this.deviceEntries.rightBottomText))])])])])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;